export default {
  supportUrl: 'support@messagespring.com',
}
